<template>
  <navbar
    position="fixed"
    type="default"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    :paddingTop="paddingTop"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img v-lazy="'/img/logo_mini.png'" width="100%"/>
      </router-link>
    </template>
    <template slot="navbar-menu">
      <!-- <li class="nav-item">
        <router-link
          class="nav-link"
          to="/"
        >
          <p>{{$t(`menu_home`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/land"
        >
          <p>{{$t(`menu_land`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/governance"
        >
          <p>{{$t(`menu_governance`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/skin"
        >
          <p>{{$t(`menu_skin`)}}</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/media"
        >
          <p>{{$t(`menu_media`)}}</p>
        </router-link>
      </li> -->
      <drop-down
              tag="li"
              v-bind:title="$t($i18n.locale)"
              class="nav-item"
      >
        <div @click="$i18n.locale='en'" class="dropdown-item">
          English
        </div>
        <!-- <div @click="$i18n.locale='ko'" class="dropdown-item">
          한국어
        </div>
        <div @click="$i18n.locale='ch-zn'" class="dropdown-item">
          中文
        </div> -->
        <div @click="$i18n.locale='ja'" class="dropdown-item">
          日本語
        </div>
      </drop-down>
      <!-- <li v-if="$i18n.locale == 'ko'" class="nav-item" style="margin-left: 30px;">
        <a href="https://cafe.naver.com/lokofficial" target="_blank">
          <img v-lazy="'/img/icon_contact_naver.png'" height="35px" />
        </a>
        <a href="https://twitter.com/LeagueKingdoms" target="_blank">
          <img v-lazy="'/img/icon_contact_twitter.png'" height="35px" />
        </a>
        <a href="https://medium.com/league-of-kingdoms-eng" target="_blank">
          <img v-lazy="'/img/icon_contact_midium.png'" height="35px" />
        </a>        
        <a href="https://discord.gg/t22KuEB" target="_blank">
          <img v-lazy="'/img/icon_contact_discord.png'" height="35px" />
        </a>
      </li>
      <li v-else class="nav-item" style="margin-left: 30px;">
        <a href="https://twitter.com/LeagueKingdoms" target="_blank">
          <img v-lazy="'/img/icon_contact_twitter.png'" height="35px" />
        </a>
        <a href="https://www.facebook.com/LofK.Official" target="_blank">
          <img v-lazy="'/img/icon_contact_facebook.png'" height="35px" />
        </a>        
        <a href="https://medium.com/league-of-kingdoms-eng" target="_blank">
          <img v-lazy="'/img/icon_contact_midium.png'" height="35px" />
        </a>
        <a href="https://discord.gg/t22KuEB" target="_blank">
          <img v-lazy="'/img/icon_contact_discord.png'" height="35px" />
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <n-button
          class="nav-link btn btn-info"
          style="cursor: pointer;"
          @click="openModal('subscribe')"
        >
          <p>{{$t('SUBSCRIBE')}}</p>
        </n-button>
      </li> -->
      <!-- <li class="nav-item">
        <div
          style="cursor: pointer; background-image: url('/img/event/btn_event.png'); background-size: 100% 100%; width: 42px; height: 46px; margin-left: 10px;"
          @click="goEvent()"
        >
        </div>
      </li> -->
    </template>
  </navbar>
</template>

<script>
import { DropDown, Button, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    paddingTop: Boolean
  },
  methods: {
    openModal: function(modalName) {
      this.$store.commit(`openModal`, modalName);
    },
    goEvent() {
      let url = "//land.leagueofkingdoms.com/event" + localStorage.urlParam;
      window.open(url, "_blank");
    }
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Button.name]: Button,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
